import React, { useState } from 'react';
import './PropertyLoan.css';
import LoanAgainstPropertyImage from '../images/Loan-Against-Property.jpg';
import LoanAgainstSharesBg from '../images/loan-against-shares.jpg';
import LoanAgainstPropertyPNG from '../images/loan-against-property.png';

const PropertyLoan = () => {
  const [activeTab, setActiveTab] = useState('eligibility');

  return (
    <div className="property-loan-page" style={{ backgroundImage: `url(${LoanAgainstSharesBg})` }}>
      {/* Banner Section */}
      <section className="property-loan-banner">
        <div className="property-banner-container">
          <div className="property-banner-left">
            <div className="property-banner-image" style={{ backgroundImage: `url(${LoanAgainstPropertyImage})` }}>
              <div className="property-image-overlay">
                <h1 className="property-banner-title">LOAN AGAINST PROPERTY</h1>
              </div>
            </div>
          </div>
          <div className="property-banner-right">
            <div className="property-banner-content">
              <h2 className="property-banner-subtitle">WE OFFER A FULL RANGE OF LOAN AGAINST PROPERTY</h2>
              <p className="property-banner-description">
                A loan against property (LAP) is a secured loan where to procure financing, people use their owned property as collateral. Such a loan allows borrowers to secure higher amounts for longer repayment periods, making monthly EMIs manageable. This solution is suitable for those seeking more affordable EMIs and the flexibility to meet various financial needs, whether personal or business-related.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Features/Benefits Section */}
      <section className="property-features-section">
        <div className="property-features-container">
          <h2 className="property-features-heading">FEATURES/BENEFITS</h2>
          <div className="property-features-content">
            <div className="property-features-image-wrapper">
              <img src={LoanAgainstPropertyPNG} alt="Loan Against Property Features" className="property-features-image" />
            </div>
            <div className="property-features-list">
              <div className="property-feature-item">
                <h3 className="property-feature-title">LOAN TENURE</h3>
                <p className="property-feature-description">Avail a flexible loan tenure of up to 10 years.</p>
              </div>
              <div className="property-feature-item">
                <h3 className="property-feature-title">MAXIMUM LOAN AMOUNT</h3>
                <p className="property-feature-description">Avail loans in the range of Rs.5 Lakhs to Rs. 1 Crores.</p>
              </div>
              <div className="property-feature-item">
                <h3 className="property-feature-title">FAST & HASSLE-FREE PROCESSING</h3>
                <p className="property-feature-description">Receive funds within 72 hours* with our well-organized approval process.</p>
              </div>
              <div className="property-feature-item">
                <h3 className="property-feature-title">CUSTOMIZABLE REPAYMENT OPTIONS</h3>
                <p className="property-feature-description">Benefit from our EMIs and part prepayment scheme for more control over your finances.</p>
              </div>
              <div className="property-feature-item">
                <h3 className="property-feature-title">COMPETITIVE INTEREST RATES</h3>
                <p className="property-feature-description">Get Loan against Property at attractive interest rates starting from just 12%*.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Eligibility and Documents Section */}
      <section className="property-eligibility-section">
        <div className="property-eligibility-container">
          <div className="property-tabs">
            <button 
              className={`property-tab ${activeTab === 'eligibility' ? 'active' : ''}`}
              onClick={() => setActiveTab('eligibility')}
            >
              Eligibility Criteria
            </button>
            <button 
              className={`property-tab ${activeTab === 'documents' ? 'active' : ''}`}
              onClick={() => setActiveTab('documents')}
            >
              Required Documents
            </button>
          </div>

          {activeTab === 'eligibility' && (
            <div className="property-tab-content">
              <div className="property-eligibility-grid">
                <div className="property-eligibility-card">
                  <h3 className="property-eligibility-title">SALARIED INDIVIDUALS</h3>
                  <p className="property-eligibility-text">
                    Must be a resident of India having age between 21-55 years. They should be employed with a public, private or a multinational organization.
                  </p>
                </div>
                <div className="property-eligibility-card">
                  <h3 className="property-eligibility-title">SELF-EMPLOYED INDIVIDUALS</h3>
                  <p className="property-eligibility-text">
                    Must be a resident of India having age between 21-55 years. They should be a business person with a stable business income.
                  </p>
                </div>
              </div>
            </div>
          )}

          {activeTab === 'documents' && (
            <div className="property-tab-content">
              <div className="property-documents-grid">
                <div className="property-documents-card">
                  <h3 className="property-documents-title">AGE PROOF<br />(ANY TWO OF THE FOLLOWING)</h3>
                  <ul className="property-documents-list">
                    <li>PAN Card</li>
                    <li>Aadhar Card</li>
                    <li>ITR or Financial Statements</li>
                    <li>Property documents for mortgage</li>
                    <li>Property title documents</li>
                  </ul>
                </div>
                <div className="property-documents-card">
                  <h3 className="property-documents-title">ADDRESS PROOF<br />(ANY TWO OF THE FOLLOWING)</h3>
                  <ul className="property-documents-list">
                    <li>Latest salary slips (For salaried individuals)</li>
                    <li>Bank account statements for the last 3 months (For Salaried Individuals). 6 months (For Self Employed Professionals)</li>
                    <li>PAN card or Form 60 (for all applicants)</li>
                    <li>Valid ID proof</li>
                    <li>Address proof</li>
                    <li>Property documents for mortgage</li>
                    <li>Income Tax returns</li>
                    <li>Property title documents</li>
                  </ul>
                </div>
                <div className="property-documents-card">
                  <h3 className="property-documents-title">INCOME PROOF<br />(ANY TWO OF THE FOLLOWING)</h3>
                  <ul className="property-documents-list">
                    <li>ITR of the latest 2 years along with computation (When borrower is an individual)</li>
                    <li>Audited/ CA certified Profit and Loss Account and Balance Sheet (When borrower is a company/ firm)</li>
                    <li>Bank account statements for the last 1 year (Savings and Current Account)</li>
                  </ul>
                </div>
              </div>
            </div>
          )}
        </div>
      </section>

      {/* Learn More Section */}
      <section className="property-learn-more-section">
        <div className="property-learn-more-container">
          <div className="property-learn-more-content">
            <h2 className="property-learn-more-title">Learn More About Our Services</h2>
            <p className="property-learn-more-text">Reach out to us for inquiries.</p>
          </div>
          <a href="/contact" className="property-contact-btn">Contact Us</a>
        </div>
      </section>
    </div>
  );
};

export default PropertyLoan;
